module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-index",
    style: (_vm.swipe_offset_style)
  }, _vm._l((_vm.slides_len), function(item, i) {
    return _c('span', {
      staticClass: "index",
      class: {
        active: i === _vm.swiper.realIndex
      },
      on: {
        "click": function($event) {
          _vm.index_trigger === 'click' && _vm.$emit('active', i)
        },
        "mouseenter": function($event) {
          _vm.index_trigger === 'hover' && _vm.$emit('active', i)
        }
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9917b4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swipe/components/index.vue
// module id = 690
// module chunks = 0